export enum OAuthProvider {
  Azure = 'azure',
  Google = 'google',
}

export const getOAuthProviderName = (provider: OAuthProvider) => {
  switch (provider) {
    case OAuthProvider.Azure:
      return 'Microsoft';
    case OAuthProvider.Google:
      return 'Google';
  }
};

export const isOAuthProvider = (value: any) =>
  [OAuthProvider.Azure, OAuthProvider.Google].includes(value);
